<div class="copilot-message-container" *ngIf="webInsights">
  <div class="copilot-message-header">
    <span class="copilot-message-icon">
      <img [src]="'svg/signal-feed.svg' | assetVersion"/>
    </span>
    <div class="copilot-web-insights-title">
      Market Signals
    </div>
  </div>
  <div class="copilot-message-content">
    <app-markdown *ngIf="isLegacy" [rawMarkdown]="legacyContent"></app-markdown>
    <div class="web-insight" *ngFor="let item of insightItems">
      <img [src]="'svg/chevron-right.svg' | assetVersion" class="chevron"/>
      <span class="web-insight-text">{{ item.insight }}
        <div class="preview-container" *ngFor="let src of item.sources">
        <a [href]="src.link" target="_blank" class="source-badge"
           cdkOverlayOrigin #badgeOrigin="cdkOverlayOrigin"
           (mouseenter)="openPreview(src)" (mouseleave)="scheduleClosePreview()">
          {{ src.name }} <i class="icon-external-link"></i>
          <img [src]="'svg/redirect-link.svg' | assetVersion" class="hover-svg"/>
        </a>

        <ng-template cdkConnectedOverlay
                     [cdkConnectedOverlayOrigin]="badgeOrigin"
                     [cdkConnectedOverlayOpen]="hoveredSource === src"
                     [cdkConnectedOverlayPositions]="previewPositions">
          <div class="hover-card" (mouseenter)="openPreview(src)" (mouseleave)="scheduleClosePreview()">
            <a [href]="src.link" target="_blank">
            <h4 class="card-title">{{ src.name }} | {{ src.title }}</h4>
            <p class="card-url">{{ src.link }}
            </p>
              </a>
          </div>
        </ng-template>
      </div>
        </span>
    </div>
  </div>
</div>
